/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { GtoStyle, GtoUom, TakeOffParamDto, TakeOffParamSharedListItemDto } from './top.dto';

export const TakeOffParamMapper = entity<TakeOffParamDto>({
  gtoStyle: enumeration(GtoStyle),
  gtoUom: enumeration(GtoUom),
});

export const TakeOffParamSharedListItemMapper = entity<TakeOffParamSharedListItemDto>();
